export default "__VITE_ASSET__BD5_268D__"